module.exports = __webpack_public_path__ + "img/Skadedyrsbekæmpelse.6b3fff78.jpg";